<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div class="dashboard-title">Manage Cohorts</div>
    </div>

    <div *ngIf="isSuperAdmin">
      <mat-divider></mat-divider>
      <div class="subtitle-row">
        <button *ngIf="isSuperAdmin" color="primary" mat-stroked-button routerLink="/admin/edit-cohort">
          Add New Cohort
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>

  <div class="table-container">
    <table [dataSource]="dataSource" mat-table aria-describedby="App Config List">
      <ng-container matColumnDef="name">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div (click)="toggleSingleSort('name')" class="header-with-sort">
            <span>Cohort Name</span>
            <span [class]="sortBy['name']" id="sort-icon-container">
              <fc-sort-icon [column]="'name'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" class="cohort-name" mat-cell>
          {{ row.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="region">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div (click)="toggleSingleSort('region')" class="header-with-sort">
            <span>Cohort Region</span>
            <span [class]="sortBy['region']" id="sort-icon-container">
              <fc-sort-icon [column]="'region'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell>{{ row.region.name }}</td>
      </ng-container>

      <ng-container matColumnDef="buyer">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div (click)="toggleSingleSort('buyer')" class="header-with-sort">
            <span>Cohort Buyer</span>
            <span [class]="sortBy['buyer']" id="sort-icon-container">
              <fc-sort-icon [column]="'buyer'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell>{{ row.buyer.name }}</td>
      </ng-container>

      <ng-container matColumnDef="enrollmentStartDate">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div (click)="toggleSingleSort('enrollment_start_date')" class="header-with-sort">
            <span>Enrollment Start Date</span>
            <span [class]="sortBy['enrollment_start_date']" id="sort-icon-container">
              <fc-sort-icon
                [column]="'enrollment_start_date'"
                [sortBy]="sortBy"
                [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell>{{ row.enrollmentStartDate }}</td>
      </ng-container>

      <ng-container matColumnDef="enrollmentEndDate">
        <th scope="col" *matHeaderCellDef mat-header-cell>
          <div (click)="toggleSingleSort('enrollment_end_date')" class="header-with-sort">
            <span>Enrollment End Date</span>
            <span [class]="sortBy['enrollment_end_date']" id="sort-icon-container">
              <fc-sort-icon [column]="'enrollment_end_date'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell>{{ row.enrollmentEndDate }}</td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr (click)="clickRow($event, row)" *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
  </div>
</div>
